import React from "react";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomDomainPanel from "./CustomDomainPanel";
import { outlinedButtonSx } from "../../../Organization/CodeSecurity/codeSecurityShared";
import { DialogHeader, dialogActionsSx } from "../../components/DialogParts";

// ComplyJet-style: the page is always public. Document gating is Access
// requests. Settings is the custom domain only.
const TrustCenterSettingsDialog = ({
  open,
  data,
  regoditLink,
  onConnectDomain,
  onCheckDomain,
  onRemoveDomain,
  onClose,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: "12px" } }}
    >
      <DialogHeader title="Trust Center settings" onClose={onClose} />
      <DialogContent sx={{ pt: 1 }}>
        <CustomDomainPanel
          data={data}
          regoditLink={regoditLink}
          onConnect={onConnectDomain}
          onCheck={onCheckDomain}
          onRemove={onRemoveDomain}
        />
      </DialogContent>
      <DialogActions sx={dialogActionsSx(theme)}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={outlinedButtonSx(theme)}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrustCenterSettingsDialog;
